import React, { FC } from 'react'
import classNames from 'classnames'
import { getImage } from '../../../app/utlis/imageConstants';
import DynamicSVG from '../../atoms/DynamicSvg/DynamicSvg';

interface ReliabilityEDSSystemProps {
  epdSystemData: any
}

const EPDIdeaProject: FC<ReliabilityEDSSystemProps> = ({ epdSystemData }) => {

  return (
    <div className='flex flex-col gap-2 md:gap-12 pt-12 bg-darkGreyPrimary'>
      {epdSystemData.EPDSystemIdeaProjectsData.map((projects: any) => {
         let img = getImage(projects.image ?? "") ?? "";
        return (
          <div key={projects.title} className='bg-darkGreyPrimary py-2 md:py-12'>
            <div className={`flex flex-col md:flex-${projects.row} px-4 md:px-40 gap-6 md:gap-10 justify-center`}>
              <div className={classNames('flex flex-col w-full md:w-2/4 pl-0 md:pl-6', `flex-${projects.row}`)}>
                <div className={classNames('font-semibold text-3xl md:text-4xl', `text-${projects.textColor}`)} >{projects.title}</div>
                <div className={classNames('text-greyQuaternary text-base md:text-lg pt-1 pb-6 md:pb-10', `text-${projects.text}`)}>{projects.subtitle}</div>
                <ul className={`grid grid-cols-1 md:grid-cols-2 gap-3 justify-between border border-${projects.textColor} list-disc p-4 md:p-6 md:px-10`}>
                  {projects.steps.map((step:any) => {
                    return (
                      <li className={`font-bold text-lg md:text-xl`}>{step.title}</li>
                    )
                  })}
                </ul>
              </div>
              <div className={`bg-blackDark w-full md:w-2/5 h-[450px]`}>
              <DynamicSVG size='w-full h-full'>{img}</DynamicSVG>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default EPDIdeaProject
